import React from 'react';
import { useStore } from '../stores/store';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const RequireAuth: React.FC = () => {
  const {
    userStore: { IsLoggedIn },
  } = useStore();
  const location = useLocation();

  if (!IsLoggedIn) return <Navigate to="/" state={location} />;

  return <Outlet />;
};

export { RequireAuth };
